import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutPixelParams, checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'primary' | 'outline';
  className?: string;
}
const variants = {
  primary: 'bg-orange-500 text-slate-950 shadow-sm hover:bg-orange-400 focus-visible:outline-orange-500',
  outline: 'border border-orange-400/60 text-orange-400 hover:border-orange-400 hover:bg-orange-400/10 focus-visible:outline-orange-400 [.chalk_&]:border-orange-600/60 [.chalk_&]:text-orange-600 [.chalk_&]:hover:border-orange-600 [.chalk_&]:hover:bg-orange-600/10'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-5 py-4 text-sm min-[400px]:text-base sm:px-8 sm:text-lg' : 'px-5 py-3.5 text-base sm:px-6';
  const handleClick = () => {
    // Only checkout links count as a purchase start.
    if (href !== checkoutUrl) return;
    trackPixelEvent('InitiateCheckout', checkoutPixelParams);
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex max-w-full items-center justify-center gap-2.5 whitespace-nowrap rounded-full font-bold uppercase leading-none tracking-wide transition-[background-color,border-color,color,transform] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-49" data-mp="3exb41p0udogn">
      <span data-id="element-50" data-mp="1jhf8eajb3fg">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.4} aria-hidden="true" data-id="element-51" data-mp="1lahlhe471hn" />
    </a>;
}